import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/UI';

export default function BookingConfirmScreen() {
    const navigate = useNavigate();
    const { state = {} } = useLocation();
    const { type, id, data = {}, confirmationNumber, paymentUrl, qrUrl } = state;

    const isTicket = type === 'ticket';
    const isAppt = type === 'appointment';
    const isOrder = type === 'order';

    const emoji = isTicket ? '🎟' : isAppt ? '📅' : '🛍';
    const title = isTicket ? 'Ticket Confirmed!' : isAppt ? 'Appointment Booked!' : 'Order Placed!';
    const subtitle = isAppt ? 'Check your Email for your Confirmation and QR Code.'
        : isTicket ? 'Your Ticket is Confirmed. Check your Email for your QR Code.'
            : 'Your Order has been Received.';

    return (
        <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-primary)', padding: 24 }}>
            <div style={{ maxWidth: 480, margin: '0 auto', paddingTop: 32 }}>
                {/* Success */}
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <div style={{
                        width: 120, height: 120, borderRadius: '50%',
                        backgroundColor: 'var(--bg-card)', border: '2px solid var(--brand-500)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 16px', fontSize: 52
                    }}>{emoji}</div>
                    <h1 style={{
                        fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 800,
                        marginBottom: 8
                    }}>{title}</h1>
                    <p style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.5, maxWidth: 300, margin: '0 auto' }}>
                        {subtitle}
                    </p>
                </div>

                {/* Confirmation number */}
                {confirmationNumber && (
                    <div style={{
                        backgroundColor: 'var(--bg-surface)', borderRadius: 16, padding: 16,
                        textAlign: 'center', marginBottom: 16, border: '1px solid var(--border)'
                    }}>
                        <p style={{
                            color: 'var(--text-muted)', fontSize: 11, fontWeight: 600,
                            textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4
                        }}>Confirmation #</p>
                        <p style={{
                            color: 'var(--brand-300)', fontSize: 22, fontWeight: 800,
                            fontFamily: 'var(--font-mono)'
                        }}>{confirmationNumber}</p>
                    </div>
                )}

                {/* Details */}
                <div style={{
                    backgroundColor: 'var(--bg-card)', borderRadius: 16, padding: 16,
                    marginBottom: 16, border: '1px solid var(--border)'
                }}>
                    <p style={{ fontFamily: 'var(--font-display)', fontSize: 16, fontWeight: 700, marginBottom: 12 }}>
                        Booking Details
                    </p>
                    {Object.entries(data).map(([k, v]) => v ? (
                        <div key={k} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
                            paddingBottom: 8, marginBottom: 8, borderBottom: '1px solid var(--border)'
                        }}>
                            <span style={{ color: 'var(--text-muted)', fontSize: 13, textTransform: 'capitalize' }}>
                                {k.replace(/([A-Z])/g, ' $1').trim()}
                            </span>
                            <span style={{
                                color: 'var(--text-primary)', fontSize: 13, fontWeight: 600,
                                textAlign: 'right', maxWidth: '55%'
                            }}>{String(v)}</span>
                        </div>
                    ) : null)}
                </div>

                {/* Payment */}
                {paymentUrl && (
                    <div style={{
                        backgroundColor: '#422006', borderRadius: 16, padding: 16,
                        marginBottom: 16, border: '1px solid #f59e0b'
                    }}>
                        <p style={{ color: '#fbbf24', fontSize: 15, fontWeight: 700, marginBottom: 4 }}>💳 Payment Required</p>
                        <p style={{ color: '#fde68a', fontSize: 13, marginBottom: 12 }}>Complete your Payment to finalize your Booking.</p>
                        <a href={paymentUrl} target="_blank" rel="noreferrer" style={{
                            display: 'block', backgroundColor: '#f59e0b', borderRadius: 10, padding: '12px',
                            textAlign: 'center', color: '#000', fontWeight: 700, fontSize: 15, textDecoration: 'none',
                        }}>Pay Now →</a>
                    </div>
                )}

                {/* QR */}
                {qrUrl && (
                    <div style={{
                        backgroundColor: 'var(--bg-surface)', borderRadius: 16, padding: 16,
                        marginBottom: 16, border: '1px solid var(--border)', textAlign: 'center'
                    }}>
                        <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.5 }}>
                            📱 Your QR Code has been sent to your Email. Show it at the Venue for Entry.
                        </p>
                    </div>
                )}

                {/* Actions */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <Button label="Back to Home" onClick={() => navigate('/')} fullWidth />
                    <Button label="View My Bookings" variant="outline" onClick={() => navigate('/bookings')} fullWidth />
                </div>
            </div>
        </div>
    );
}
